import { HierarchyContextProps, IHierarchyActionRemoveDomainReplacement } from "./interface";

/**
 * Removes a domain replacement from the hierarchy context state.
 *
 * @param action - The action containing the domain replacement to remove
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state without the specified domain replacement
 */
export const hcr_removeDomainReplacement = (
  action: IHierarchyActionRemoveDomainReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  const ix = state.hierarchy.domainReplacements.findIndex(
    (dr) => dr.airid === action.domainReplacement!.airid,
  );
  if (ix > -1) {
    return {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        domainReplacements: state.hierarchy.domainReplacements.filter(
          (dr) => dr.airid !== action.domainReplacement!.airid,
        ),
      },
    };
  }
  return state;
};
